import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledLogoutSVG = styled.svg<IconProps>`
  & .cls-1,
  .cls-3 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }

  & .cls-3 {
    stroke: var(--chatbot-color-primary, #404040);
  }
`;

const LogoutIcon: React.FC<IconProps> = ({ active }) => {
  const activeclass = active ? 'active' : undefined;
  return (
    <StyledLogoutSVG
      id='Logout-Icon-SVG'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <g id='Logout' transform='translate(-36 76) rotate(-90)'>
        <rect id='Margin' className='cls-1' width='32' height='32' transform='translate(76 36) rotate(90)' />
        <g id='Group_17474' data-name='Group 17474' transform='translate(20.267 11.5)'>
          <path
            id='Path_15950'
            data-name='Path 15950'
            className='cls-2'
            d='M45.641,45.652a7.286,7.286,0,1,1,0-10.3q.143.143.278.295h1.546a8.5,8.5,0,1,0,0,9.714H45.92Q45.785,45.508,45.641,45.652Z'
          />
          <line id='Line_397' data-name='Line 397' className='cls-3' x1='8.233' transform='translate(39.233 40.5)' />
        </g>
      </g>
    </StyledLogoutSVG>
  );
};

export default LogoutIcon;
